<template>
    <div class="pageCenter">
        <slot></slot>
    </div>
</template>
<script>
    export default{
        name:'PageCenter',
        data(){
            return{
                headHeight:0,
                footHeight:0
            }
        },
        mounted(){

        },
        created(){
        },
        computed:{

        },
        methods:{

        },
        components:{
        }
    }
</script>
<style scoped>
    .pageCenter{
        /*padding-top: 2.1rem;
        background: url("../../assets/images/bg/top_bg.png") repeat-x;*/
        background-size:   100% 4.5rem;
    }
</style>